import { render, staticRenderFns } from "./landingPageFooter.vue?vue&type=template&id=3d7b01a7&scoped=true&"
import script from "./landingPageFooter.vue?vue&type=script&lang=ts&"
export * from "./landingPageFooter.vue?vue&type=script&lang=ts&"
import style0 from "./landingPageFooter.vue?vue&type=style&index=0&id=3d7b01a7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d7b01a7",
  null
  
)

export default component.exports